export default __webpack_public_path__ + "static/media/logo.24cb0e1b.jpg";